export default __webpack_public_path__ + "static/media/bike-rider.0825234e.png";